<div class="wellness-bell-container">
  <button class="btn-wellness-bell" (click)="toggleNotifications($event)">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
    <span class="bell-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
  </button>

  <!-- Notifications dropdown -->
  <div class="wellness-dropdown" *ngIf="showNotifications">
    <div class="wellness-dropdown-header">
      <strong class="wellness-title">{{ 'wellness.notifications-title' | translate }}</strong>
    </div>
    <hr class="wellness-divider">
    <div class="wellness-notification-list">
      <div class="wellness-notification-item"
           *ngFor="let notification of wellnessNotifications"
           [class.read]="notification.read"
           (click)="onNotificationClick(notification)">
        <div class="notification-icon"
             (mouseenter)="onNotificationHover($event, notification.id)"
             (mouseleave)="hoveredNotificationId = null">
          <img ngSrc="/assets/images/icons/icon-wellness.svg" alt="Wellness" width="28" height="28">
        </div>
        <div class="notification-content">
          <span class="notification-student">{{ notification.studentName }}</span>
          <span class="notification-class">{{ notification.className }}</span>
        </div>
        <span class="notification-date">{{ formatNotificationDate(notification.date) }}</span>
      </div>
      <div class="wellness-empty" *ngIf="wellnessNotifications.length === 0">
        {{ 'wellness.no-notifications' | translate }}
      </div>
    </div>
  </div>
</div>

<!-- Click outside overlay -->
<div class="notifications-overlay" *ngIf="showNotifications" (click)="showNotifications = false"></div>

<!-- Wellness Tooltip (fixed, outside dropdown) -->
<div class="wellness-tooltip-fixed" *ngIf="hoveredNotificationId !== null"
     [style.top.px]="tooltipTop" [style.left.px]="tooltipLeft">
  <div class="wellness-tooltip-header">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
    <strong>{{ 'wellness.tooltip.title' | translate }}</strong>
  </div>
  <p>{{ 'wellness.tooltip.description-1' | translate }}</p>
  <p>{{ 'wellness.tooltip.description-2' | translate }}</p>
  <p>{{ 'wellness.tooltip.description-3' | translate }}</p>
</div>

<!-- Wellness Notification Popup -->
<app-wellness-popup
  [notification]="selectedNotification"
  (closed)="closeNotificationPopup()"
  (goToProfile)="goToStudentProfile()">
</app-wellness-popup>
